module.exports = __webpack_public_path__ + "img/inprogress.57f7cfc3.gif";